export default {
  name: 'Icon',
  displayName: {
    en: 'Icon',
    ja: 'アイコン',
  },
  icon: 'icon.png',
  defaultWidth: 24,
  defaultHeight: 24,
  props: [
    {
      name: 'iconName',
      displayName: {
        en: 'Icon',
        ja: 'アイコン',
      },
      type: 'icon',
      default: 'directions-bike',
    },
    {
      name: 'iconColor',
      displayName: {
        en: 'Color',
        ja: '色',
      },
      type: 'color',
      default: '#666666',
    },
    {
      name: 'onPress',
      type: 'action',
      displayName: {
        en: 'Icon',
        ja: 'Icon',
      },
    },
  ],
  resizeX: true,
  resizeY: true,
  attributes: {
    size: {
      displayName: {
        en: 'Icon size',
        ja: 'アイコンサイズ',
      },
    },
    iconColor: true,
  },
};
